// SMART goal examples, ABC scenarios, and quizzes for Session 1

export const SMART_EXAMPLES = [
  {
    goal: "Mejorar en mi trabajo siendo más rápido con el ordenador.",
    smart: true,
    reasons: [
      { criterion: "Específico y positivo", ok: true },
      { criterion: "Medible", ok: true },
      { criterion: "Alcanzable", ok: true },
      { criterion: "Relevante", ok: true },
      { criterion: "Definido en el tiempo", ok: true },
    ],
  },
  {
    goal: "Dejar de ser irritable.",
    smart: false,
    reasons: [
      { criterion: "Específico y positivo", ok: false },
      { criterion: "Medible", ok: false },
      { criterion: "Alcanzable", ok: false },
      { criterion: "Relevante", ok: true },
      { criterion: "Definido en el tiempo", ok: true },
    ],
  },
  {
    goal: "Volver a tener confianza.",
    smart: false,
    reasons: [
      { criterion: "Específico y positivo", ok: false },
      { criterion: "Medible", ok: false },
      { criterion: "Alcanzable", ok: false },
      { criterion: "Relevante", ok: true },
      { criterion: "Definido en el tiempo", ok: true },
    ],
  },
  {
    goal: "Poder dormir 4 de 7 noches a la semana por lo menos 7-8 horas.",
    smart: true,
    reasons: [
      { criterion: "Específico y positivo", ok: true },
      { criterion: "Medible", ok: true },
      { criterion: "Alcanzable", ok: true },
      { criterion: "Relevante", ok: true },
      { criterion: "Definido en el tiempo", ok: true },
    ],
  },
  {
    goal: "Sentirme mejor.",
    smart: false,
    reasons: [
      { criterion: "Específico y positivo", ok: false },
      { criterion: "Medible", ok: false },
      { criterion: "Alcanzable", ok: true },
      { criterion: "Relevante", ok: true },
      { criterion: "Definido en el tiempo", ok: true },
    ],
  },
];

export const SMART_CRITERIA = [
  { key: "specific", label: "Específico y positivo" },
  { key: "measurable", label: "Medible" },
  { key: "attainable", label: "Alcanzable" },
  { key: "relevant", label: "Relevante" },
  { key: "timeBound", label: "Definido en el tiempo" },
];

export const SMART_QUIZ = {
  id: "smart-quiz",
  title: "Autoevaluación · Objetivos SMART",
  questions: [
    {
      id: "q1",
      text: "¿Por qué es importante que un objetivo sea específico?",
      options: [
        { key: "A", text: "Porque debe ser fácil de entender." },
        { key: "B", text: "Porque permite mayor precisión y claridad en lo que se desea lograr." },
        { key: "C", text: "Porque se enfoca en una sola tarea." },
        { key: "D", text: "Porque debe ser general para abarcar más aspectos." },
      ],
      correct: "B",
    },
    {
      id: "q2",
      text: "¿Qué aspectos del objetivo 'Volver a tener confianza' hacen que no cumpla SMART?",
      options: [
        { key: "A", text: "Es específico pero no medible." },
        { key: "B", text: "No es específico y no se puede medir." },
        { key: "C", text: "Es relevante pero no alcanzable." },
        { key: "D", text: "Está definido en el tiempo pero no es específico." },
      ],
      correct: "B",
    },
    {
      id: "q3",
      text: "Sobre el objetivo 'Poder dormir 4 de 7 noches al menos 7-8 horas', ¿cómo cumple SMART?",
      options: [
        { key: "A", text: "No es medible." },
        { key: "B", text: "Es específico, medible, alcanzable, relevante y definido en el tiempo." },
        { key: "C", text: "No es relevante." },
        { key: "D", text: "No está definido en el tiempo." },
      ],
      correct: "B",
    },
  ],
};

// ABC scenarios (reframe negative -> positive thought)
export const ABC_REFRAME_SCENARIOS = [
  {
    id: "r1",
    event: "No has terminado el trabajo y tu jefe te llama a su despacho.",
    negative_thoughts: ["Me va a gritar y a decir que soy un inútil.", "Me va a despedir por no hacer el trabajo."],
    negative_emotions: ["Ansiedad", "Miedo"],
    positive_thoughts: [
      "Mi jefe probablemente quiere saber si necesito ayuda para terminar el trabajo.",
      "Mi jefe aprecia mi esfuerzo y quiere apoyarme.",
    ],
    positive_emotions: ["Tranquilidad", "Optimismo"],
  },
  {
    id: "r2",
    event: "Llegas tarde a una reunión familiar importante y todos ya están esperando.",
    negative_thoughts: [
      "Todos estarán enfadados conmigo por hacerlos esperar.",
      "Soy un desastre por no poder llegar a tiempo a nada.",
    ],
    negative_emotions: ["Culpa", "Ansiedad", "Tristeza"],
    positive_thoughts: [
      "Mi familia entenderá si les explico por qué llegué tarde.",
      "Mis seres queridos estarán felices de verme, incluso si llego tarde.",
    ],
    positive_emotions: ["Comprensión", "Aceptación", "Gratitud"],
  },
  {
    id: "r3",
    event: "Has olvidado el cumpleaños de un amigo cercano y te llama al respecto.",
    negative_thoughts: [
      "Mi amigo estará muy decepcionado conmigo.",
      "Soy una mala persona por olvidar algo tan importante.",
    ],
    negative_emotions: ["Vergüenza", "Remordimiento", "Ansiedad"],
    positive_thoughts: [
      "Puedo disculparme sinceramente y planear algo especial para compensarlo.",
      "Mi amigo sabe que, aunque olvidé la fecha, la amistad es importante para mí.",
    ],
    positive_emotions: ["Esperanza", "Tranquilidad", "Optimismo"],
  },
  {
    id: "r4",
    event: "Te encuentras en un atasco y tienes una cita médica a la que llegar.",
    negative_thoughts: [
      "Nunca llegaré a tiempo y causaré una mala impresión.",
      "Siempre me pasan estas cosas, es frustrante.",
    ],
    negative_emotions: ["Estrés", "Frustración"],
    positive_thoughts: [
      "Puedo usar este tiempo para repasar mentalmente lo que diré en la cita.",
      "Todos entienden que el tráfico es impredecible.",
    ],
    positive_emotions: ["Calma", "Optimismo"],
  },
  {
    id: "r5",
    event: "Olvidas comprar un ingrediente clave para la cena que planeaste.",
    negative_thoughts: ["He arruinado la cena.", "Soy despistado y siempre olvido cosas importantes."],
    negative_emotions: ["Desilusión", "Ansiedad"],
    positive_thoughts: [
      "Puedo improvisar y usar otro ingrediente que tenga disponible.",
      "Mis amigos entenderán y valorarán el esfuerzo.",
    ],
    positive_emotions: ["Satisfacción", "Optimismo"],
  },
];

// 10 identify-the-situation quiz — user is given the thought (B) + consequence (C)
// and must pick which situation/event (A) most likely triggered them.
export const ABC_IDENTIFY = {
  id: "abc-identify-quiz",
  title: "Práctica · Identifica la situación",
  intro: "Lee el pensamiento (B) y la consecuencia (C). Elige la situación (A) que mejor los explica.",
  scenarios: [
    {
      id: "s1",
      thought: "No voy a ser capaz de aprender cómo se hace.",
      consequence: "Ansiedad, nerviosismo, sudoración, palpitaciones.",
      options: [
        { key: "A", text: "Estás enseñando algo que dominas a un compañero nuevo." },
        { key: "B", text: "Tienes que aprender algo en el trabajo y otras personas parecen aprenderlo antes que tú." },
      ],
      correct: "B",
      explanation: "Compararte con otros que 'aprenden antes' activa un pensamiento de incapacidad ('no voy a poder'), y ese pensamiento dispara la respuesta fisiológica de ansiedad. La situación de comparación es la que enciende toda la cadena.",
    },
    {
      id: "s2",
      thought: "Puedo usar esto para mejorar y crecer profesionalmente.",
      consequence: "Motivación, optimismo, determinación.",
      options: [
        { key: "A", text: "Recibes una crítica constructiva de tu jefe sobre tu desempeño." },
        { key: "B", text: "Vas a comer con tus compañeros de trabajo un viernes." },
      ],
      correct: "A",
      explanation: "Una crítica se puede leer como amenaza o como oportunidad. Cuando la interpretas como oportunidad de crecimiento, el cuerpo responde con motivación en lugar de defensa. Es la lectura, no la crítica, lo que decide la emoción.",
    },
    {
      id: "s3",
      thought: "Puedo prepararme bien y hacerlo lo mejor que pueda.",
      consequence: "Calma, confianza, motivación.",
      options: [
        { key: "A", text: "Estás viendo una película tranquilamente en casa." },
        { key: "B", text: "Tienes que hacer una presentación frente a un gran grupo." },
      ],
      correct: "B",
      explanation: "Un reto real (presentación pública) puede producir calma si el pensamiento se centra en el control ('puedo prepararme') en vez de en el fracaso. El pensamiento realista transforma el miedo en preparación.",
    },
    {
      id: "s4",
      thought: "La otra persona entenderá si le explico por qué llegué tarde.",
      consequence: "Calma, tranquilidad.",
      options: [
        { key: "A", text: "Llegas tarde a una cita importante y la otra persona está esperando." },
        { key: "B", text: "Llegas justo a tiempo a una reunión con un amigo." },
      ],
      correct: "A",
      explanation: "Llegar tarde suele activar culpa, pero un pensamiento comprensivo ('entenderá si le explico') mantiene la calma. La situación existe; es tu interpretación la que decide cómo la vives.",
    },
    {
      id: "s5",
      thought: "Nuestra relación está arruinada y nunca volverá a ser igual.",
      consequence: "Tristeza profunda, desesperanza, angustia.",
      options: [
        { key: "A", text: "Compartes una tarde tranquila viendo una serie con tu pareja." },
        { key: "B", text: "Tienes una fuerte discusión con un ser querido." },
      ],
      correct: "B",
      explanation: "Una discusión con alguien querido activa un pensamiento catastrófico ('todo se ha roto') que dispara tristeza profunda. Sin la situación de conflicto, ese pensamiento no aparece: por eso reconocerla es clave para cuestionarlo.",
    },
    {
      id: "s6",
      thought: "Puedo reportarlo y tomar medidas para recuperarlos o reemplazarlos.",
      consequence: "Calma, optimismo.",
      options: [
        { key: "A", text: "Pierdes tu cartera con documentos importantes." },
        { key: "B", text: "Encuentras un billete olvidado en un bolsillo viejo." },
      ],
      correct: "A",
      explanation: "Perder documentos genera pánico solo si el pensamiento es catastrófico. Con un pensamiento orientado a la solución ('puedo reportarlo'), la calma sustituye a la angustia. Tu foco cambia el resultado emocional.",
    },
    {
      id: "s7",
      thought: "No conoceré a nadie y me sentiré incómodo toda la noche.",
      consequence: "Inseguridad, ansiedad, nerviosismo.",
      options: [
        { key: "A", text: "Quedas para cenar con tus amigos de toda la vida." },
        { key: "B", text: "Te invitan a una fiesta donde no conoces a casi nadie." },
      ],
      correct: "B",
      explanation: "La incertidumbre social (no conocer a nadie) activa un pensamiento anticipatorio negativo ('me sentiré incómodo') que produce ansiedad antes incluso de vivir la situación. Reconocer esa anticipación es el primer paso para cambiarla.",
    },
    {
      id: "s8",
      thought: "Todo el mundo piensa lo mismo y no soy lo suficientemente bueno.",
      consequence: "Tristeza, inseguridad, baja autoestima.",
      options: [
        { key: "A", text: "Recibes un comentario negativo sobre una publicación tuya en redes sociales." },
        { key: "B", text: "Publicas una foto en redes y recibes muchos comentarios positivos." },
      ],
      correct: "A",
      explanation: "Un comentario individual se generaliza mentalmente ('todo el mundo piensa lo mismo') y se vincula con la autoestima ('no soy bueno'). Esta cadena de sobregeneralización produce tristeza intensa a partir de una sola opinión.",
    },
    {
      id: "s9",
      thought: "Estoy preparado y puedo demostrar mis habilidades.",
      consequence: "Confianza, calma, motivación.",
      options: [
        { key: "A", text: "Estás durmiendo la siesta un domingo por la tarde." },
        { key: "B", text: "Vas a una entrevista para un puesto que realmente deseas." },
      ],
      correct: "B",
      explanation: "Una entrevista importante puede generar pánico o confianza. Un pensamiento de autoafirmación ('estoy preparado') convierte una situación amenazante en un escenario de oportunidad, sin que la realidad externa haya cambiado.",
    },
    {
      id: "s10",
      thought: "Será divertido y una gran experiencia.",
      consequence: "Entusiasmo, apertura, ilusión.",
      options: [
        { key: "A", text: "Estás a punto de probar un nuevo deporte que nunca has practicado." },
        { key: "B", text: "Ves a otras personas practicando un deporte por televisión." },
      ],
      correct: "A",
      explanation: "Empezar algo nuevo genera incertidumbre. Un pensamiento abierto ('será divertido') transforma esa incertidumbre en entusiasmo en lugar de miedo. La situación es la misma; el marco mental cambia toda la experiencia.",
    },
  ],
};

export const SESSIONS_META = [
  { number: 1, title: "Primeros pasos, objetivos y Modelo ABC", unlocked: true },
  { number: 2, title: "El estrés y los pensamientos automáticos", unlocked: false },
  { number: 3, title: "Las distorsiones del pensamiento", unlocked: false },
  { number: 4, title: "Errores de pensamiento, ansiedad, depresión y afrontamiento", unlocked: false },
  { number: 5, title: "Las creencias internas", unlocked: false },
  { number: 6, title: "Creencias internas (II) y estilos atribucionales", unlocked: false },
  { number: 7, title: "Estilos atribucionales (II)", unlocked: false },
  { number: 8, title: "El fin del camino", unlocked: false },
];
